import { render, staticRenderFns } from "./AssignmentBooks.vue?vue&type=template&id=2b45a080&scoped=true&"
import script from "./AssignmentBooks.vue?vue&type=script&lang=js&"
export * from "./AssignmentBooks.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentBooks.vue?vue&type=style&index=0&id=2b45a080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b45a080",
  null
  
)

export default component.exports